import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import { useTheme } from '@mui/material/styles';
import { useResponsive } from 'src/hooks/use-responsive';
import Logo from 'src/components/logo';
import ArticleList from 'src/components/article/ArticleList';

// ----------------------------------------------------------------------

export default function AuthClassicLayout({ children, image, title }) {
  const theme = useTheme();
  const mdUp = useResponsive('up', 'md');

  const renderContent = (
    <Stack
      sx={{
        width: 1,
        maxWidth: 480, // Set max width for the children content
        bgcolor: '#f9f9f9', // Almost white background color
        px: { xs: 2, md: 8 },
        py: { xs: 8, md: 10 },
        boxShadow: theme.shadows[24],
        borderRadius: 2,
        mx: 'auto',
        textAlign: 'center', // Center content within the stack
      }}
    >
      <Logo
        sx={{
          mx: 'auto',
          mb: 4, // Add some margin below the logo
          width: 200, // Set desired width for the logo
          height: 'auto', // Maintain aspect ratio
        }}
      />
      {children}
    </Stack>
  );

  

  return (
    <Stack
      component="main"
      direction="column"
      justifyContent="space-between"
      alignItems="center"
      sx={{
        minHeight: '100vh',
        bgcolor: '#e0e0e0', // Light grey background color
        py: 3,
      }}
    >
      <Stack
        justifyContent="center"
        alignItems="center"
        sx={{
          flex: 1,
          width: '100%',
        }}
      >
        {renderContent}
      </Stack>

      
    </Stack>
  );
}

AuthClassicLayout.propTypes = {
  children: PropTypes.node,
  image: PropTypes.string,
  title: PropTypes.string,
};
